import { BaseMessage } from "./baseMessage";

export abstract class AbstractConfigurationMessage extends BaseMessage {

  protected readonly CONFIGURATION_ID = "configurationId";

  get configurationId(): number { return this.getInternalValue<number>(this.CONFIGURATION_ID); }
  setConfigurationId(configurationId: number): this { return this.setInternalValue(this.CONFIGURATION_ID, configurationId); }
}